<template>
    <div>
        <div v-if="show">
            <b-col md="12">
                <b-spinner variant="secondary" class="mr-1" />
                <span class="text-secondary">Consultando Balance...</span>
            </b-col>
        </div>
        <div v-else>
            <b-col md="12">
                <b-form-input v-model="amount" size="lg" :disabled="disabled" />
            </b-col>
            <b-col md="12" class="mt-1">
                <b-button
                    variant="primary"
                    @click="loadFormPayPal()"
                    block
                    size="lg"
                    :disabled="disabled"
                >
                    Confirmar Valor de Pago
                </b-button>
            </b-col>
            <b-col md="12" class="mt-5">
                <b-form align="center">
                    <div id="paypal-button-container"></div>
                </b-form>
            </b-col>
        </div>
    </div>
</template>

<script>
import {
    BButton,
    BCard,
    BCol,
    BForm,
    BFormInput,
    BRow,
    BSpinner,
} from "bootstrap-vue";

export default {
    components: {
        BCard,
        BRow,
        BCol,
        BSpinner,
        BForm,
        BFormInput,
        BButton,
    },
    props: {
        idcontrato: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            show: false,
            userData: JSON.parse(localStorage.getItem("userData")),
            keyPayPal: null,
            amount: 0,
            disabled: false,
        };
    },
    created() {
        this.searchBalance();
        this.loadPayPal();
    },
    methods: {
        searchBalance() {
            this.show = true;
            this.$http
                .get("/contrato-balance/", {
                    params: {
                        idcontrato: this.idcontrato,
                        opresumen: 1,
                    },
                })
                .then((response) => {
                    this.show = false;
                    if (response.data) {
                        this.amount = response.data.data;
                    }
                })
                .catch(function (error) {
                    this.show = false;
                    console.log(error);
                });
        },
        loadPayPal() {
            this.$http
                .get("/paypal/", {
                    params: {
                        estado: "A",
                    },
                })
                .then((response) => {
                    this.keyPayPal = response.data.data.key_private;
                    this.loadJsPayPal();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        loadJsPayPal() {
            let paypal = document.createElement("script");
            paypal.setAttribute(
                "src",
                "https://www.paypal.com/sdk/js?client-id=" + this.keyPayPal
            );
            document.head.appendChild(paypal);
        },
        loadFormPayPal() {
            this.disabled = true;
            let amount = String(this.amount);
            paypal
                .Buttons({
                    createOrder: function (data, actions) {
                        return actions.order.create({
                            purchase_units: [
                                {
                                    amount: {
                                        value: amount,
                                    },
                                },
                            ],
                        });
                    },
                    onApprove: function (data, actions) {
                        return actions.order.capture().then(function (details) {
                            axios
                                .post("/paypal/", {
                                    id: details.id,
                                    status: details.status,
                                    res: details,
                                    idcontrato: this.idcontrato,
                                })
                                .then((response) => {
                                    let msn = response.data.msn;

                                    if (msn == "COMPLETED") {
                                        router.push({ name: "pago-resumen" });
                                    } else {
                                        router.push({ name: "pago-error" });
                                    }
                                })
                                .catch(function (error) {
                                    console.log(error);
                                });
                        });
                    },
                    onError: function (err) {
                        console.log(err);
                        router.push({ name: "pago-error" });
                        this.disabled = false;
                    },
                })
                .render("#paypal-button-container");
        },
    },
};
</script>
